import React from "react";
import { X } from "lucide-react";

export default function VideoPreviewModal({ videoUrl, title, onClose }) {
  if (!videoUrl) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-black rounded-xl overflow-hidden max-w-md w-full relative">

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 bg-white rounded-full p-1"
        >
          <X size={18} />
        </button>

        {/* Video */}
        <video
          src={videoUrl}
          controls
          autoPlay
          className="w-full h-auto"
        />

        <div className="p-3 bg-white text-sm font-semibold text-gray-700">
          {title}
        </div>

      </div>
    </div>
  );
}